import { v4 as uuidv4 } from 'uuid';
import { mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';
import isMobile from 'is-mobile';
import moment from 'moment';

export default {
	props: {
		name: { type: [String, Number], default: null },
		options: { type: Object, default: () => {} },
		disabled: { type: Boolean, default: false },
		index: { type: Number, default: null },
		type: { type: String, default: 'calculation' },
	},
	mounted() {
		this.rules = this.options.rules;
	},
	data() {
		return {
			value: this.options.type === 'checkbox' || this.options.type === 'radio' ? false : '',
			rules: null,
		};
	},
	computed: {
		...mapGetters(['getDataByGroup', 'getRealEstate']),
		...mapGetters('contracting', ['getFormData', 'getDataByProp']),
		hasValue() {
			/* if(this.options.inputGroup === 'real_estate') {
                return this.options.hasValue && this.getRealEstate.id === null;
            }

            return this.options.hasValue; */
			return false;
		},
		generatedId() {
			return `${this.name}_${uuidv4()}`;
		},
		computedValue() {
			return value => {
				if (_.has(this.options, 'format') && this.options.format) {
					value = value.replace(/\s/g, '');
				}

				if (
					this.options.type === 'checkbox' ||
					this.options.type === 'radio' ||
					this.options.type === 'chooser'
				) {
					return value === 'true';
				} else if (typeof value === 'boolean') {
					return value;
				} else if (value === null) {
					return null;
				} else if (value === '' || value === ' ') {
					return null;
				} else if (this.options.type === 'phone') {
					return value;
                //FIXME:
				} else if (!isNaN(value) && !(this.options.className+"").includes("uglyfix-class-fixme-please")) {
					return parseInt(value);
				} else if (this.options.type === 'date') {
					return moment(value, 'yyyy.MM.DD.').format('yyyy-MM-DD');
				} else {
					return value;
				}
			};
		},
		computedName() {
			return _.has(this.options, 'name') ? this.options.name : this.name;
		},
		isMobile() {
			return isMobile();
		},
		isVisible() {
			if (_.has(this.options, 'visibleIf')) {
				return this.$store.getters[this.options.visibleIf];
			}

			if (_.has(this.options, 'visibleIfValue')) {
				return this.getData(this.options.visibleIfValue.prop) === this.options.visibleIfValue.value;
			}

			return true;
		},
	},
	methods: {
		...mapMutations(['setInputData', 'setMobileMenu']),
		...mapMutations('contracting', ['setFormData', 'setValueByProp']),
		async onChange(e) {
			this.setData(this.computedValue(this.options.type === 'switch' ? e.target.checked : e.target.value));

			if (this.isMobile) {
				this.setMobileMenu(false);
			}

			if (_.has(this.options, 'onChange')) {
				await this.$store.dispatch(this.options.onChange);
			}

			this.$emit('change', e);

			if (this.makeNotifierErrors !== undefined) {
				this.makeNotifierErrors();
			}
		},
		formatValue(value) {
			if (_.has(this.options, 'format')) {
				if (this.options.format) {
					return this.$options.filters.formatNumber(value);
				}
			}

			return value;
		},
		getData(prop = null) {
			if (this.type === 'calculation') {
				const data = this.getDataByGroup(
					this.options.inputGroup,
					this.options.index === undefined ? this.index : this.options.index,
				);

				if (prop !== null) {
					return data !== undefined ? data[prop] : null;
				}

				return data !== undefined ? data[this.computedName] : null;
			}

			if (this.type === 'contracting') {
				if (this.options.input === undefined) {
					return this.getDataByProp(this.name);
				}

				return this.getFormData({
					parent: this.options.input.parent,
					group: this.options.input.group,
					prop: prop === null ? this.options.input.prop : prop,
					index: this.options.index === undefined ? this.index : this.options.index ?? null,
				});
			}
		},
		setData(value) {
			if (this.type === 'calculation') {
				this.setInputData({
					group: this.options.inputGroup,
					key: this.computedName,
					value: value,
					index: this.options.index === undefined ? this.index : this.options.index,
				});
			}

			if (this.type === 'contracting') {
				if (this.options.input === undefined) {
					this.setValueByProp({
						prop: this.name,
						payload: value,
					});
				} else {
					this.setFormData({
						parent: this.options.input.parent,
						group: this.options.input.group,
						prop: this.options.input.prop,
						value,
						index: this.options.index === undefined ? this.index : this.options.index ?? null,
					});
				}
			}
		},
		addRules(rules) {
			this.rules = { ...this.rules, ...rules };
		},
	},
};
